/* eslint-disable jsx-a11y/anchor-is-valid */

import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import withIntegrationCardContext from 'hoc/withIntegrationCardContext';
import Slider from 'react-slick';

const BigCommerce = ({ sliderSettings }) => {
  const { img1 } = useStaticQuery(graphql`
    {
      img1: file(relativePath: { eq: "marketplace/bigcommerce/1.png" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  `);
  const photos = [
    {
      img: img1.childImageSharp.gatsbyImageData,
      alt: 'BigCommerce Integration',
      title: 'Integrate BigCommerce with LiveSession',
    },
  ];
  return (
    <>
      <Slider {...sliderSettings(photos)} className="without-dots">
        <div>
          <GatsbyImage image={photos[0].img} alt={photos[0].alt} title={photos[0].title} />
        </div>
      </Slider>
      <div className="section">
        <h2>Overview</h2>
        <p>
          BigCommerce is one of the most popular e-commerce solutions. You can add a LiveSesion
          script to your BigCommerce website to see how the users interact with your online shop.
        </p>
      </div>
      <div className="section">
        <h2>Benefits</h2>
        <ul className="checkmarks">
          <li>Learn more about your visitors and potential customers</li>
          <li>Discover potential issues</li>
          <li>Improve conversions on your e-commerce site</li>
        </ul>
      </div>
      <h2>How to install</h2>
      <p>
        Just copy and paste a piece of code. See a detailed tutorial in our{' '}
        <a href="/help/how-install-on-bigcommerce/">help center</a>.
      </p>
    </>
  );
};

export default withIntegrationCardContext(BigCommerce);

BigCommerce.propTypes = {
  sliderSettings: PropTypes.func.isRequired,
};
